import SilentWitnessTextItem from './SilentWitnessTextItem';

const SilentWitnessTextGroup = ({ group }) => {
  return (
    <>
      {group.items.map((item) => (
        <SilentWitnessTextItem
          key={`${group.key}-${item.index}`}
          item={item}
          groupKey={group.key}
        />
      ))}
    </>
  );
};

export default SilentWitnessTextGroup;
